import React from "react";
import pluralize from "pluralize";

import StarOutlineIcon from "components/Icons/star_outline.svg";
import StarSolidIcon from "components/Icons/star_solid.svg";

type Props = {
  value: number;
  name: string;
  filled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  onChange: (x: any) => void;
  starSize?: number;
};

const RadioStar = ({
  value,
  name,
  filled = false,
  onChange,
  starSize = 27,
}: Props) => {
  const id = `RadioStar__${name}__${value}`;
  return (
    <>
      <div
        className="relative"
        style={{
          height: starSize,
          width: starSize,
        }}
      >
        <input
          name={name}
          value={value}
          type="radio"
          className="opacity-0 absolute inset-1/2"
          id={id}
          onChange={(ev) => onChange(ev.target.value)}
        />
        <label className="absolute cursor-pointer" htmlFor={id}>
          {filled ? (
            <StarSolidIcon height={starSize} width={starSize} />
          ) : (
            <StarOutlineIcon height={starSize} width={starSize} />
          )}
          <span className="sr-only">{`${value} ${pluralize(
            "star",
            value,
          )}`}</span>
        </label>
      </div>

      <style jsx>{`
        input:focus + label {
          outline: black solid 1px;
        }
      `}</style>
    </>
  );
};

export default RadioStar;
